export default __webpack_public_path__ + "static/media/uomo.13edfce4.jpeg";